import type { TenantConfig } from "./types";

// kch — first school tenant (Chinese-speaking, zh-CN default).
// Matches the tenants/kch.env.example shape at the repo root.
export const kchTenant: TenantConfig = {
  slug: "kch",
  displayName: "KCH School",
  tagline: "校园 AI 门户",
  defaultLocale: "zh-CN",
  subjects: [
    { agentId: "chemistry-assistant", labelKey: "chat.subjects.chemistry" },
    { agentId: "math-assistant", labelKey: "chat.subjects.math" },
    { agentId: "english-assistant", labelKey: "chat.subjects.english" },
  ],
  brand: {
    logoSrc: "/brand/favicon.svg",
  },
};
